import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
interface NavbarProps {
  cartCount: number;
  onCartClick: () => void;
}
export function Navbar({
  cartCount,
  onCartClick
}: NavbarProps) {
  return <nav className="sticky top-0 z-[100] flex items-center justify-between border-b border-[#e8e8e8] bg-white px-5 py-[18px] shadow-[0_2px_10px_rgba(0,0,0,0.05)] md:px-10" data-id="element-88">
      <div className="select-none" data-id="element-89">
        <img src="https://cdn.magicpatterns.com/uploads/kN6UgmugCg8qEnn5sfM52v/logo.png" alt="RÔA Imported" className="h-[50px] w-auto" data-id="element-90" />
      </div>

      <ul className="hidden list-none gap-[30px] md:flex" data-id="element-91">
        <li data-id="element-92">
          <a href="#" className="text-[13px] uppercase tracking-[2px] text-[#1a1a1a] no-underline transition-colors duration-300 hover:text-[#888]" data-id="element-93">
            Inicio
          </a>
        </li>
        <li data-id="element-94">
          <a href="#coleccion" className="text-[13px] uppercase tracking-[2px] text-[#1a1a1a] no-underline transition-colors duration-300 hover:text-[#888]" data-id="element-95">
            Colección
          </a>
        </li>
        <li data-id="element-96">
          <a href="#" className="text-[13px] uppercase tracking-[2px] text-[#1a1a1a] no-underline transition-colors duration-300 hover:text-[#888]" data-id="element-97">
            Marcas
          </a>
        </li>
        <li data-id="element-98">
          <a href="#" className="text-[13px] uppercase tracking-[2px] text-[#1a1a1a] no-underline transition-colors duration-300 hover:text-[#888]" data-id="element-99">
            Contacto
          </a>
        </li>
      </ul>

      <button onClick={onCartClick} className="relative cursor-pointer border-none bg-transparent p-1" aria-label={`Carrito de compras, ${cartCount} productos`} data-id="element-100">
        <ShoppingBagIcon className="h-[22px] w-[22px] text-[#1a1a1a]" data-id="element-101" />
        <span className="absolute -right-2 -top-2 flex h-[18px] w-[18px] items-center justify-center rounded-full bg-[#1a1a1a] text-[10px] font-bold text-white" data-id="element-102">
          {cartCount}
        </span>
      </button>
    </nav>;
}